var _path, _circle, _circle2, _circle3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2344 6.15792C23.4474 7.17227 26.8938 10.2859 23.7132 15.0482C22.1246 17.0781 19.7231 17.1664 18.5942 17.1664L17.1308 17.3131C17.0792 17.3182 17.0282 17.3281 16.9785 17.3424L16.54 17.469C16.4251 17.5023 16.3183 17.5592 16.2267 17.6361L10.2437 22.661C10.2247 22.677 10.2065 22.6941 10.1884 22.7112C10.1569 22.7408 10.1255 22.7705 10.0896 22.7941C9.90995 22.9126 9.48275 23.0312 8.77538 23.1239C8.18578 23.2011 7.333 23.1687 6.66392 23.1432C6.46167 23.1356 6.27621 23.1285 6.11987 23.1253C5.97979 23.1225 5.83827 23.0947 5.72824 23.0079C5.51157 22.8371 5.30392 22.5486 5.5098 22.2192C5.77173 21.8001 8.15706 17.7619 9.35464 15.7313C9.38082 15.6869 9.40988 15.6463 9.44443 15.6081C9.70275 15.3225 10.2166 14.8384 10.5626 14.8054C10.9229 14.7711 16.3434 14.7201 19.2335 14.697C19.393 14.6958 19.5486 14.6517 19.6796 14.5608C21.2549 13.4682 23.1603 10.9807 19.6881 8.63339C19.5533 8.54225 19.3896 8.49493 19.2269 8.49493H11.157C11.1177 8.49493 11.0786 8.49856 11.0395 8.50219C11.0066 8.50526 10.9736 8.50833 10.9404 8.50922C10.4774 8.52158 9.4725 8.00665 8.40027 5.78096C7.10288 3.61864 6.00402 1.70448 5.54306 0.887706C5.49162 0.796547 5.45421 0.697031 5.45589 0.59237C5.46002 0.333818 5.56172 0 5.95109 0H9.19168C9.2672 0 9.34187 0.00934347 9.41382 0.0322631C9.72079 0.130043 10.2508 0.350077 10.5626 0.661942C10.9157 1.01498 14.4901 4.0452 16.2333 5.51619C16.4539 5.65593 16.9393 5.93542 17.1158 5.93542H19.8775C19.9195 5.93542 19.961 5.93851 20.0026 5.94467L21.0188 6.09522C21.0937 6.10631 21.1656 6.12637 21.2344 6.15792ZM3.04861 6.1218L7.95572 10.2874C8.5294 10.6625 9.3149 11.6907 7.86746 12.8028C6.44112 14.0916 4.00679 16.1264 2.88137 17.0543C2.82343 17.1021 2.75192 17.129 2.67689 17.1318L0.491914 17.2135C0.452036 17.215 0.411932 17.2103 0.375275 17.1945C0.169456 17.1059 -0.102958 16.8685 0.12273 16.4655C0.365747 16.0316 1.852 13.4568 2.60076 12.1613C2.62572 12.1181 2.64065 12.0714 2.64379 12.0216C2.67616 11.5089 2.61544 10.5001 2.14062 9.96885C2.11977 9.94552 2.10151 9.92122 2.08642 9.8938C1.71651 9.22152 0.603311 7.45932 0.0488415 6.59327C0.0245297 6.5553 0.00746394 6.51366 0.00342322 6.46875C-0.0159315 6.25365 0.0382946 5.93095 0.387494 5.96269C0.76468 5.99698 1.94952 5.97854 2.54293 5.96398C2.57687 5.96314 2.61062 5.96731 2.64333 5.9764L2.91852 6.05284C2.96637 6.06613 3.01075 6.08966 3.04861 6.1218Z",
    fill: "url(#paint0_linear_5491_10753)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.251,
    cy: 11.8564,
    r: 1.08691,
    fill: "url(#paint1_linear_5491_10753)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.624,
    cy: 11.8564,
    r: 1.08691,
    fill: "url(#paint2_linear_5491_10753)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.999,
    cy: 11.8564,
    r: 1.08691,
    fill: "url(#paint3_linear_5491_10753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5491_10753",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 23.1722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5491_10753",
    x1: 12.251,
    y1: 10.7695,
    x2: 12.251,
    y2: 12.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5491_10753",
    x1: 15.624,
    y1: 10.7695,
    x2: 15.624,
    y2: 12.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5491_10753",
    x1: 18.999,
    y1: 10.7695,
    x2: 18.999,
    y2: 12.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCEEF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/Flight.10137eecf47a5271ee9d00962c584a82.svg";
export { ForwardRef as ReactComponent };